<template>
    <div
        v-if="widgetToSetup"
        class="widget-custom-setup-step"
    >
        <div class="flex items-center gap-5 px-5">
            <div class="flex items-center gap-4">
                <div class="flex-center flex-shrink-0">
                    <component
                        :is="templateIconComponent"
                        class="text-primary w-12"
                    />
                </div>
                <div>
                    <div class="text-base font-semibold text-primary">
                        {{ templateName }}
                    </div>
                    <div class="text-sm" />
                </div>
            </div>
        </div>
        <div class="min-h-40 py-5 px-5">
            <WidgetTemplateSettingsForm
                ref="widgetTemplateSettingsFormRef"
                v-model="widgetToSetup"
                :uniq-templates-configs="uniqTemplatesConfigs"
                :show-statistics-to-display="showStatisticsToDisplay"
                :show-status-select="showStatusSelect"
                :show-time-frame="showTimeFrame"
                show-title-field
                @update:configs="updateFilterItem"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import { IWidgetTemplateListItem } from '@/types/templates'
import { useVModel } from '@vueuse/core'
import { computed, ref } from 'vue'
import { templateIcons } from '@/enum/widgetDataTypes'
import { isCounterAgentsInStatus, isQueueDashboardWidget, shouldShowTimeFrame } from '@/helpers/widgetUtils'
import { WidgetConfig } from '@/types/dashboard'
import orderBy from 'lodash/orderBy'
import WidgetTemplateSettingsForm from '@/components/RedesignComponents/Widgets/Create/WidgetTemplateSettingsForm.vue'

const props = defineProps<{
    templateName?: string
    value: IWidgetTemplateListItem
}>()
const emit = defineEmits<{
    (e: 'update:value', value: IWidgetTemplateListItem): void
    (e: 'back'): void
    (e: 'input', value: IWidgetTemplateListItem): void
}>()

const widgetTemplateSettingsFormRef = ref<typeof WidgetTemplateSettingsForm>()

const widgetToSetup = useVModel(props, 'value', emit, { eventName: 'input' })

const widgetConfigModel = computed({
    get () {
        return widgetToSetup.value.WidgetConfig || []
    },
    set (val) {
        widgetToSetup.value.WidgetConfig = [ ...val ]
    }
})

const templateIconComponent = computed(() => {
    const _key = widgetToSetup.value?.DataType?.DataTypeID as keyof typeof templateIcons
    return (_key !== undefined ? templateIcons[_key] : '') || templateIcons.Default
})
const showStatisticsToDisplay = computed(() => {
    return isQueueDashboardWidget(widgetToSetup.value)
})
const showStatusSelect = computed(() => {
    return isCounterAgentsInStatus(widgetToSetup.value.DataType)
})
const showTimeFrame = computed(() => {
    return shouldShowTimeFrame(widgetToSetup.value)
})

const uniqTemplatesConfigs = computed(() => {
    const templates = orderBy(widgetToSetup.value.WidgetConfig, [ 'ParameterType' ], [ 'desc' ])
    return [ ...templates ] as unknown as Array<WidgetConfig>
})

// function onBack () {
//     emit('back')
// }
function updateFilterItem (config: WidgetConfig) {
    widgetConfigModel.value = [ ...widgetConfigModel.value ].map(i => {
        if (i.ParameterID === config.ParameterID) {
            return {
                ...config
            }
        }
        return i
    }) || []
}

defineExpose({
    validate: () => widgetTemplateSettingsFormRef.value?.validate()
})
</script>
